const REMINDER_EXCLUDED_TYPES = ["ReminderTerm"] as const;

export const getNotificationExcludedTypes = (hasRemindersRight: boolean) =>
	hasRemindersRight ? undefined : REMINDER_EXCLUDED_TYPES;
